export interface MathfieldKeyboardOptions {
    mathField: HTMLElement;
    keyboard: {
      show(): void;
      hide(): void;
    };
    isOpen: () => boolean;
    setOpen: (v: boolean) => void;
    //updateLayout: () => void;
    pageContainerSelector?: string;  // defaults to '.page-container'
    pageOriginalHeight: string;
  }
  
  export function attachMathfieldKeyboardListeners(opts: MathfieldKeyboardOptions) {
    const sel = opts.pageContainerSelector || '.page-container';
  
    opts.mathField.addEventListener('pointerdown', () => {
      if (opts.isOpen()) return;
      setTimeout(() => {
        opts.keyboard.show();
        opts.setOpen(true);
        opts.mathField.focus();
        updateMathFieldKeyboard();
        const pageContainer = document.querySelector(sel) as HTMLElement;
        if (pageContainer) {
          const currentHeight = opts.pageOriginalHeight || pageContainer.style.height;
          // // Doing it this way because the height of this container in this project has a dynamic component due to seb
          if (currentHeight && currentHeight !== '') {
              pageContainer.style.height = `calc(${currentHeight} - 242px)`; // 242px is the height of the keyboard
          }else{
              pageContainer.style.height = 'calc(100% - 242px)'; // default
          }
        }
      }, 100);
    });
  
    opts.mathField.addEventListener('blur', (e: FocusEvent) => {
      setTimeout(() => {
        if (document.activeElement?.tagName.toLowerCase() === 'math-field') {
          return;
        }
        if (!opts.isOpen()) return;
        const pageContainer = document.querySelector(sel) as HTMLElement;
        if (pageContainer) {
          if (pageContainer) {
            const previousHeight = opts.pageOriginalHeight;
            // Doing it this way because the height of this container in this project has a dynamic component due to seb
            if (previousHeight && previousHeight !== '') {
              pageContainer.style.height = previousHeight; // 242px is the height of the keyboard
            }else{
                pageContainer.style.height = ''; // default
            }
          }
        }
        opts.keyboard.hide();
        opts.setOpen(false);
      }, 300);
    });
  }
  
  export function updateMathFieldKeyboard() {
    // THe observer here is disbabled because we are currently utilising the event handling the opening and closing of the keuboard.
    // if that is removes, this observer can be used to patch the keycap registry. Please preserve the commented lines.

    //const observer = new MutationObserver(() => {
    const registry = (window as any).mathVirtualKeyboard?.keycapRegistry;
    // For some reason, afterViewInit is called twice simultaneously before the first call disconnects the observer, the second call is
    //  already executed
    const alreadyPatched = Object.values(registry || {}).some(
      (entry: any) => entry.latex === '\\times'
    );
    // if(alreadyPatched){
    //   return;
    //   // observer.disconnect();
    // }
    if (registry && Object.keys(registry).length > 0 && !alreadyPatched) {
      for (const key in registry) {
        const entry = registry[key];
        if (entry.label === '&times;') {
          entry.latex = '\\times';
          entry.variants = [...(entry.variants || []), '\\times'];
          break;
        }
      }
    }
    // });
    //   observer.observe(document.body, {
    //   childList: true,
    //   subtree: true,
    // });
  }